import {
  applicationStore,
  betStore,
  loadingStore,
  lobbyStore,
  roundInfoStore,
  userInfoStore,
  DefaultQueryParams,
  parseQuery,
} from '@pascal/pascal-core';
import { ANIMATION_DURATION } from '../enums/constants';
import { RoomType } from '../enums/roomType';

class LobbyService {
  onGetInitialStateResult(data) {
    const { rate, hasDemo, balance, gameTypes, precision, currencyCode, currentWinners } = data;
    roundInfoStore.setRoundFinAnimationDuration(ANIMATION_DURATION);
    const {
      [DefaultQueryParams.CurrencySymbol]: currencySymbol,
      [DefaultQueryParams.UserId]: userId,
    } = parseQuery(window.location.search);
    if (!userId) {
      applicationStore.setIsGuest(true);
    }
    const sortedGameTypes = [];
    Object.keys(RoomType).forEach((item) => {
      const searchedItem = gameTypes.find((gameType) => gameType.room.toUpperCase() === item);
      if (searchedItem) {
        sortedGameTypes.push(searchedItem);
      }
    });
    lobbyStore.setGameTypes(sortedGameTypes);
    lobbyStore.setHasDemo(hasDemo);
    betStore.setCurrentWinners(currentWinners);
    userInfoStore.setUserInfo({
      rate,
      userId,
      balance,
      precision,
      currencyCode,
      currencySymbol,
      demoBalance: 10000,
    });
    // loadingStore.updateLoading({ isLobbyInitialLoaded: true });
    loadingStore.updateLoading({ isGameInitialLoaded: false });
  }

  handleRoundFinished(data) {
    const { bets } = data;
    const lastCurrentWinners = betStore.currentWinners;
    setTimeout(() => {
      betStore.setCurrentWinners([...bets, ...lastCurrentWinners]);
    }, 4000);
  }

  handleLobbyUsersCount(data) {
    const updatedGameTypes = lobbyStore.gameTypes.map((item) =>
      item.gameTypeId === data.gameTypeId
        ? { ...item, activeUsersCount: data.activeUsersCount }
        : { ...item }
    );
    lobbyStore.setGameTypes(updatedGameTypes);
  }

  handleReconnecting() {}

  handleReconnected() {}

  handleConnectionError() {}
}

export const lobbyService = new LobbyService();
